module.exports = __webpack_public_path__ + "img/subscribe-image.26334c84.png";